import React, { forwardRef, useContext, useEffect } from 'react';
import { IPanel, Panel } from '@fluentui/react/lib/Panel';
import { IIconProps, Link, Separator, Text, Icon } from '@fluentui/react';
import { IHelpPanelProps } from './IHelpPanelProps';
import { HelpLinks } from './HelpPanelData';
import './HelpPanel.css';
import { TechRoBValidationNeeded, UATConstants } from 'src/Common/Models/UATConstants';
import { useSelector } from 'react-redux';
import { StoreState } from 'src/Store';
import UATnowAction360 from './UATnowAction360';

const HelpPanel = forwardRef<IPanel, IHelpPanelProps>((props, ref) => {
  const initialData = useSelector((state: StoreState) => state.actionReducer);
  const [showWhatsNew, setShowWhatsNew] = React.useState(false);

  const handleLinkClick = (event: any) => {
    event.preventDefault();
    window.open(event.target.href, '_blank', 'noopener, noreferrer');
  };
  const copyright = '© Microsoft ' + new Date().getFullYear().toLocaleString().replace(',', '');

  const isTechROBOrAOAITenant = (): boolean => {
    const urlParams = new URLSearchParams(new URL(window.location.href).search);
    const currentTenantId = urlParams.get('tenantId');
    const currentTenantName = urlParams.get('nodeName') || urlParams.get('tab');
    const isTechRobManageaction = TechRoBValidationNeeded(initialData?.InitActionData?.actionDetails?.details?.areaPath);
    const url = window.location.href;
    return (
      (currentTenantId === UATConstants.TenantIds.TECH_ROB || isTechRobManageaction || url.includes('/createaction/field') ||
        currentTenantId === UATConstants.TenantIds.AOAI || currentTenantName === 'AOAI Capacity')
    );
  };

  useEffect(() => {
    if (isTechROBOrAOAITenant()) {
      const techRobLink = HelpLinks.find(link => link.key === 'resources');
      if (techRobLink) {
        const existingLink = techRobLink.items.find(item =>
          item.text === UATConstants.PlaceholdersAndTitles.TechRobProcessDocumentation
        );
        if (!existingLink) {
          techRobLink.items.push({
            key: 'tech-rob-docs',
            text: UATConstants.PlaceholdersAndTitles.TechRobProcessDocumentation,
            url: UATConstants.Links.techRobProcessDocumentationLink,
          });
        }
      }
    } else {
      const techRobLink = HelpLinks.find(link => link.key === 'resources');
      if (techRobLink) {
        techRobLink.items = techRobLink.items.filter(item =>
          item.text !== UATConstants.PlaceholdersAndTitles.TechRobProcessDocumentation
        );
      }
    }
  }, [isTechROBOrAOAITenant(), initialData]);

  const handleUATisNowAction360Click = (event: any) => {
    event.preventDefault();
    setShowWhatsNew(true);
  };

  const backIcon: IIconProps = { iconName: 'Back' };

  return (
    <Panel
      componentRef={ref as any}
      headerText='Help'
      isOpen={props.isOpen}
      onDismiss={props.onDismiss}
      isLightDismiss={true}
      styles={{
        contentInner: {
          backgroundColor: '#fff',
        },
      }}
      onOuterClick={(_e) => { }}
      closeButtonAriaLabel='Close'>
      <div className='help-content'>
        {showWhatsNew ? (
          <div>
            <Link
              className='help-link'
              onClick={() => setShowWhatsNew(false)}
              style={{ marginBottom: '10px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
              <Icon {...backIcon} style={{ marginRight: '10px' }} />
            </Link><span style={{fontSize: '16px', fontWeight: '600'}}>What's New</span>
            <div className='whats-new-content'>
              <UATnowAction360 />
            </div>
          </div>
        ) : (
          HelpLinks.map((section, index) => (
            <div key={section.key} style={section.key === 'whats-new' ? { marginBottom: '20px' } : undefined}>
              <div>
                <Text className='help-header' variant='large'>
                  {section.label}
                </Text>
                {section.items.map((item, itemIndex) => (
                  <Link
                    className='help-link'
                    href={'url' in item ? item.url : '#'}
                    key={itemIndex}
                    onClick={section.key === 'whats-new' ? handleUATisNowAction360Click : handleLinkClick}
                    target={'url' in item ? '_blank' : '_self'}>
                    {item.text}
                  </Link>
                ))}
              </div>
              {index !== HelpLinks.length - 1 && section.key !== 'whats-new' && <Separator className='help-divider' />}
            </div>
          ))
        )}
      </div>
      <span className='copyrigt' title={copyright}>
        © Microsoft {new Date().getFullYear().toLocaleString().replace(',', '')}
      </span>
    </Panel>
  );
});

HelpPanel.displayName = 'HelpPanel';

export { HelpPanel };
// Generated by GitHub Copilot | Updated on: 2026-06-17 | 1 lines modified | Removed divider only between Whats New and Resources sections
